<template>
	<div class="p-0 text-grey-900" id="" style="z-index: 2">
		<div
			@click.stop="
				() => $emit('dropdownClick', { id: '', select_location: '' })
			"
			class="plus-info-inner-wrapper bg-white border-1 border position-relative my-0 my-sm-5"
		>
			<div
				class="d-flex justify-content-end sticky-top p-3 p-lg-0 m-lg-0 float-end float-lg-none"
			>

				<CloseButton @click="handleClose"/>
			</div>
			<div class="container px-0">
				<div
					class="d-lg-flex align-items-start justify-content-start px-3 pt-3 px-lg-5 pt-lg-5"
				>
					<SliderDesktop :prestation="prestation" />

					<!-- mobile -->
					<span
						class="d-lg-none plus-info-title title-2 text-start mb-3 d-block"
					>
						{{ prestation.accomodationName }}
					</span>

					<!-- / mobile -->

					<!-- mobile -->
					<SliderMobile :prestation="prestation" />
					<div v-if="prestation.virtualVisit" class="text-center">
						<u class="d-flex d-lg-none my-2">
							<a
								:href="prestation.virtualVisit"
								style="font-size: 14px; font-weight: 600; color: #52b3d8"
								target="_blank"
							>
								<span class="text-nowrap">
									<span class="me-2">{{
										content["planner_virtual_visit"]
									}}</span>
									<svg color="#52B3D8" width="20" height="16" class="icon">
										<use xlink:href="#___icon___360"></use>
									</svg>
								</span>
							</a>
						</u>
					</div>
					<!-- / mobile -->

					<div class="col-12 col-lg-7 p-0 ps-lg-4 mb-3">
						<div class="col-12 col-lg-11 d-flex flex-column nowrap px-0">
							<div class="d-flex flex-row mb-lg-2" style="gap: 10px">
								<!-- desktop -->
								<span
									class="d-none d-lg-block plus-info-title weight-700 font-24 text-start"
								>
									{{ prestation.accomodationName }}
								</span>
								<a
									class="d-none d-lg-block my-2"
									v-if="prestation.virtualVisit"
									:href="prestation.virtualVisit"
									style="font-size: 14px; font-weight: 600; color: #52b3d8"
									target="_blank"
								>
									<span class="text-nowrap">
										<span class="me-2">{{
											content["planner_virtual_visit"]
										}}</span>
										<svg color="#52B3D8" width="20" height="16" class="icon">
											<use xlink:href="#___icon___360"></use>
										</svg>
									</span>
								</a>
								<!-- desktop -->
							</div>

							<div class="d-flex flex-row mb-3">
								<div class="me-1 text-start body d-flex gap-1">
									<span>
										<svg
											:width="geoIconSize"
											:height="geoIconSize"
											class="icon text-primary-blue"
										>
											<use xlink:href="#___icon___geo"></use>
										</svg>
									</span>
									<span>
										{{ prestation.liheName }}
									</span>
								</div>
							</div>

							<InfoIcons
								:iconSize="infoIconsSize"
								:color="infoIconsColor"
								:prestation="prestation"
							/>
						</div>
						<BorderHorizontal />
						<div ref="accomodationDescription" class="body text-start mb-3">
							<div
								class="show-more-less-text"
								v-html="prestation.accomodationDescription"
							></div>
							<div class="read-more mt-2 link-small">
								<span>{{ content.liheDesc_seeMore }}</span>
								<svg class="icon tf-icon-16 text-blue-900">
									<use xlink:href="#___icon___chevron_small"></use>
								</svg>
							</div>
							<div class="read-less mt-2 link-small">
								<span>{{ content.liheDesc_seeLess }}</span>
								<svg class="icon tf-icon-16 text-blue-900">
									<use xlink:href="#___icon___chevron-up-small"></use>
								</svg>
							</div>
						</div>
					</div>
				</div>

				<div class="px-3 px-lg-5 d-md-flex my-4">
					<Advantages :prestation="prestation" />
				</div>

				<!-- BLUE BACKGROUND THINGS START -->

				<div>
					<div
						v-if=!activePrestations
						class="d-flex flex-column nowrap px-3 px-lg-5 py-3 w-100 bg-blue-100 pt-5"
					>
						<h3 class="title-2 text-grey-900 text-center pt-5 mb-4">
							{{ content.planner_summary }}
						</h3>

						<!-- DESKTOP -->

						<template v-if="screenType === 'desktop'">
							<div
								v-for="(variant, variant_i) in prestation.variants"
								class="col-12 p-0 mt-4 mb-5"
								:key="variant_i"
							>
								<div
									v-if="isPierreVacance(variant)"
									class="p-3 d-md-flex justify-content-end bg-white ps-0 pe-md-5"
									style="border-radius: 10px; border: 1px solid #dee2e6"
								>
									<PopupPrestVariantPierreVacance
										:variant="variant"
										@select="(id) => $emit('select', id)"
										@dropdownClick="(obj) => $emit('dropdownClick', obj)"
										@clear="(id) => $emit('clear', id)"
										@dropdownSelect="
											({ newSelected, id }) =>
												$emit('dropdownSelect', { newSelected, id })
										"
									/>
								</div>
								<div
									v-else
									class="p-3 d-md-flex justify-content-end bg-white ps-0 pe-md-5"
									style="border-radius: 10px; border: 1px solid #dee2e6"
								>
									<PopupPrestVariantDefault
										:variant="variant"
										@select="(id) => $emit('select', id)"
										@dropdownClick="(obj) => $emit('dropdownClick', obj)"
										@clear="(id) => $emit('clear', id)"
										@dropdownSelect="
											({ newSelected, id }) =>
												$emit('dropdownSelect', { newSelected, id })
										"
									/>
								</div>
							</div>
						</template>

						<!-- MOBILE / TABLET -->

						<template v-else>
							<div
								class="d-flex flex-row flex-wrap bg-white"
								style="border-radius: 10px; border: 1px solid #dee2e6"
							>
								<!-- DATES -->
								<div
									class="d-flex flex-column col-12 col-lg-2 text-start px-3 px-lg-0 my-2"
								>
									<span class="body-strong text-primary-blue text-start">
										{{ content.planner_prestationsDates }}
									</span>
									<div
										class="d-flex d-lg-flex text-start body text-grey-900 mb-2 me-1"
									>
										<span class="text-capitalize me-1">
											{{ content.planner_datePickerFrom }}
											{{ dates.BeginDate }}
										</span>
										<span>
											{{ content.planner_datePickerTill }}
											{{ dates.EndDate }}
										</span>
									</div>
								</div>

								<!-- PARTICIPANTS -->
								<div
									class="col-12 col-lg-2 d-flex flex-column text-start px-3 px-lg-0 my-2"
								>
									<span class="body-strong text-primary-blue">
										{{ content.planner_prestationsParticipants }}</span
									>
									<p class="body text-grey-900">
										{{ participants.length }}
										{{ content.planner_prestationsPersons }}
									</p>
								</div>

								<!-- VARIANTS -->
								<div
									v-for="(variant, variant_i) in prestation.variants"
									class="col-12 p-0 my-2"
									:key="variant_i"
								>
									<div class="px-2">
										<BorderHorizontal v-if="variant_i !== 0" />
									</div>

									<PopupPrestVariantPierreVacance
										v-if="isPierreVacance(variant)"
										:variant="variant"
										@select="(id) => $emit('select', id)"
										@dropdownClick="(obj) => $emit('dropdownClick', obj)"
										@clear="(id) => $emit('clear', id)"
										@dropdownSelect="
											({ newSelected, id }) =>
												$emit('dropdownSelect', { newSelected, id })
										"
									/>
									<PopupPrestVariantDefault
										v-else
										:variant="variant"
										@select="(id) => $emit('select', id)"
										@dropdownClick="(obj) => $emit('dropdownClick', obj)"
										@clear="(id) => $emit('clear', id)"
										@dropdownSelect="
											({ newSelected, id }) =>
												$emit('dropdownSelect', { newSelected, id })
										"
									/>
								</div>
							</div>
						</template>
					</div>

					<!-- BLUE BACKGROUND THINGS END -->

					<div class="px-3 px-lg-5" v-if="displayIncludedSection">
						<h3 class="title-3 text-grey-900 planner-included-title">
							{{ content.planner_what_is_included }}
						</h3>
						<div class="d-flex flex-row flex-wrap mb-3">
							<div class="col-12 col-lg-6 px-0">
								<AppartmentEquipment :prestation="prestation" />
								<PrivateService :prestation="prestation" />
							</div>
							<div class="col-12 col-lg-6 px-0">
								<PrivateKitchen :prestation="prestation" />
								<PrivateBathroom :prestation="prestation" />
							</div>
						</div>
					</div>
				</div>

				<div
					class="d-flex flex-column justify-content-start pb-3 px-3 pb-lg-5 px-lg-5"
				>
					<Banners
						v-if="!activePrestations"
						:lihe="liheData"
						:startDate="prestation?.variants ? prestation.variants[0].startDate: null"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { nextTick } from 'vue'
import { mapGetters, mapState } from "vuex"
import BorderHorizontal from "@/vue/common/borderHorizontal.vue"
import CloseButton from "@/vue/common/clsBtnV2.vue"
import Banners from "@/vue/planning/components/common/banners.vue"
import SliderDesktop from "@/vue/planning/components/result/prestationPopup/sliderDesktop.vue"
import SliderMobile from "@/vue/planning/components/result/prestationPopup/sliderMobile.vue"
import InfoIcons from "@/vue/planning/components/result/infoIcons.vue"
import PopupPrestVariantDefault from "./prestationPopup/PrestPopupVariantDefault.vue"
import PopupPrestVariantPierreVacance from "@/vue/planning/components/result/prestationPopup/PrestPopupVariantPierreVacance.vue"
import { isPierreVacance } from "@/vue/planning/logic/pv"
import TextShowMoreLess from "@/textShowMoreLess/textShowMoreLess.js"

import PrivateKitchen from "@/vue/planning/components/result/prestationPopup/privateKitchen.vue"
import PrivateService from "@/vue/planning/components/result/prestationPopup/privateServices.vue"
import PrivateBathroom from "@/vue/planning/components/result/prestationPopup/privateBathroom.vue"
import AppartmentEquipment from "@/vue/planning/components/result/prestationPopup/appartmentEquipment.vue"
import Advantages from "@/vue/planning/components/result/prestationPopup/advantages.vue"

import iconSizes from "@/config/iconSizes"
import colors from "@/config/colors"
import store from "@/vue/planning/store/store"

export default {
	store,
	name: "PrestationPopup",
	props: {
		prestation: {
			type: Object,
			default: () => {
				return {}
			},
		},
	},
	components: {
		BorderHorizontal,
		Advantages,
		Banners,
		SliderDesktop,
		SliderMobile,
		InfoIcons,
		PopupPrestVariantDefault,
		PopupPrestVariantPierreVacance,
		PrivateKitchen,
		PrivateBathroom,
		PrivateService,
		AppartmentEquipment,
		CloseButton
	},
	data() {
		return {
			data: {
				accomodationDescription_showMoreLess: null,
			},
		}
	},
	computed: {
		...mapState(["content", "participants", "dates", "screenType", "liheData", "activePrestations"]),
		...mapGetters(["appartementEquipments_criterias","inPrivateServices_criterias","inPrivateKitchen_criterias","inPrivateBathroom_criterias"]),
		infoIconsSize() {
			return iconSizes.xl
		},
		infoIconsColor() {
			return colors.lightBlue
		},
		geoIconSize() {
			return iconSizes.l
		},
		
		displayIncludedSection() {
			const isEquipmentsEmpty = Object.keys(this.appartementEquipments_criterias).length === 0
			const isServicesEmpty = Object.keys(this.inPrivateServices_criterias).length === 0
			const isKitchenEmpty = Object.keys(this.inPrivateKitchen_criterias).length === 0 
			const isBathroomEmpty = Object.keys(this.inPrivateBathroom_criterias).length === 0

			if(
				isEquipmentsEmpty &&
				isServicesEmpty && 
				isKitchenEmpty && 
				isBathroomEmpty
			) return false
			return true
		}
	},
	methods: {
		isPierreVacance,

		handleClose() {
			this.$emit("closePopup")
		},
	},
	mounted() {
		this.$nextTick(() => {
			const div = this.$refs["accomodationDescription"]
			const accomodationDescription_showMoreLess = new TextShowMoreLess(div, 10)
			accomodationDescription_showMoreLess.init()
			this.data.accomodationDescription_showMoreLess = accomodationDescription_showMoreLess;
			
		})
	},
}
</script>

<style scoped>
.plus-info::-webkit-scrollbar {
	height: 0;
	width: 0;
	background: transparent;
}

.plus-info::-webkit-scrollbar-thumb {
	background: transparent;
}

.popup-prestation-image-list .popup-prestation-image {
	padding: 1px;
}

.main-popup-img {
	height: 350px;
	overflow: hidden;
	border-radius: 8px;
}

.main-popup-img img {
	height: 100%;
	width: auto;
}

.slider-btn-desktop {
	top: 50%;
	transform: translateY(-50%);
	z-index: 5;
}

.slider-btn-desktop.left {
	left: 10px;
}

.slider-btn-desktop.right {
	right: 10px;
}

.popup-prestation-slider-desktop {
	overflow-x: hidden;
	overflow-y: visible;
}

.plus-info.popup {
	position: fixed;
	top: 0;
	width: 100%;
	display: none;
	z-index: 2001 !important;
	max-height: 100%;
	overflow-y: auto;
	overflow-x: hidden;
}

.plus-info-close {
	z-index: 3;
	top: 20px;
	right: 20px;
	width: 36px;
	height: 36px;
	position: inline;
	background: #f1f3f5;
}

.plus-info-close:hover {
	color: var(--primary-blue) !important;
}

@media (min-width: 576px) {
	.plus-info-inner-wrapper {
		border-radius: 20px;
	}
}

@media (min-width: 991px) {
	.plus-info.popup {
		left: 50%;
		transform: translate(-50%, 0%);
	}

	.plus-info-close {
		z-index: 3;
		top: 20px;
		right: 20px;
		width: 32px;
		height: 32px;
		position: absolute;
	}
}

.slider-list {
	overflow-x: scroll;
}

.slider-list.animate {
	transition: left 250ms ease-in-out, right 250ms ease-in-out;
}

.slider-list::-webkit-scrollbar-thumb {
	background: transparent;
}

.slider-list::-webkit-scrollbar {
	width: 0;
	height: 0;
	background: transparent;
}

.planner-included-title {
	margin: 70px 0 25px 0;
}
</style>
